<template>
  <div class="gorecharge">

    <img src="/static/img/gorecharge_bgtop.png" alt="">
    <div style="position:relative;">
      <img src="/static/img/gorecharge_bgbot.png" alt="">
      <div class="btn_box">
        <router-link to="/recharge">
        <button class="recharge_btn">立即支付</button>
        </router-link>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "gorecharge",
  components: { },
  data() {
    return {
    }
  },
  mounted() {

  },
  methods: {
  }
};
</script>
<style scoped>
.btn_box{
  position:absolute;
  top:5%;
  left:0;
  width:100%;
  text-align:center;
}
.recharge_btn{
  background-image: linear-gradient(#FFB330, #F39610);
  color:white;
  border-radius:1.5rem;
  padding:.5rem 4.5rem;
  font-size:.9rem;
}
</style>



// WEBPACK FOOTER //
// src/views/center/gorecharge.vue